import { create } from 'zustand';

export interface IkalMessage {
  id: string;
  role: 'user' | 'assistant';
  text: string;
  createdAt?: string;
}

export interface IkalToolProposal {
  conversacionId: string;
  tool: string;
  toolId: string;
  input: any;
  humanReadable: string;
}

interface IkalStore {
  open: boolean;
  conversacionId: string | null;
  messages: IkalMessage[];
  streaming: boolean;
  streamBuffer: string;
  pendingProposal: IkalToolProposal | null;
  contexto: { citaId?: string; pacienteId?: string } | null;
  queuedMessage: string | null;

  openIkal: (contexto?: { citaId?: string; pacienteId?: string }) => void;
  closeIkal: () => void;
  setConversacionId: (id: string) => void;
  addUserMessage: (text: string) => void;
  startStream: () => void;
  appendDelta: (delta: string) => void;
  commitStream: () => void;
  setPendingProposal: (p: IkalToolProposal | null) => void;
  setContexto: (c: { citaId?: string; pacienteId?: string } | null) => void;
  resetConversacion: () => void;
  queueMessage: (msg: string) => void;
  clearQueuedMessage: () => void;
  addErrorMessage: (text: string) => void;
}

let msgCounter = 0;

export const useIkalStore = create<IkalStore>((set, get) => ({
  open: false,
  conversacionId: null,
  messages: [],
  streaming: false,
  streamBuffer: '',
  pendingProposal: null,
  contexto: null,
  queuedMessage: null,

  openIkal: (contexto) => set({ open: true, contexto: contexto ?? null }),
  closeIkal: () => set({ open: false }),

  setConversacionId: (id) => set({ conversacionId: id }),

  addUserMessage: (text) =>
    set((s) => ({
      messages: [...s.messages, { id: `u-${++msgCounter}`, role: 'user', text }],
    })),

  startStream: () =>
    set({ streaming: true, streamBuffer: '' }),

  appendDelta: (delta) =>
    set((s) => ({ streamBuffer: s.streamBuffer + delta })),

  commitStream: () =>
    set((s) => {
      const text = s.streamBuffer;
      if (!text.trim()) return { streaming: false, streamBuffer: '' };
      return {
        streaming: false,
        streamBuffer: '',
        messages: [...s.messages, { id: `a-${++msgCounter}`, role: 'assistant', text }],
      };
    }),

  setPendingProposal: (p) => set({ pendingProposal: p }),

  setContexto: (c) => set({ contexto: c }),

  resetConversacion: () =>
    set({ conversacionId: null, messages: [], pendingProposal: null, streamBuffer: '', streaming: false }),

  queueMessage: (msg) => set({ queuedMessage: msg }),
  clearQueuedMessage: () => set({ queuedMessage: null }),
  addErrorMessage: (text) =>
    set((s) => ({
      streaming: false,
      streamBuffer: '',
      messages: [...s.messages, { id: `err-${++msgCounter}`, role: 'assistant', text }],
    })),
}));
